import React from 'react';
import { useSelector } from 'react-redux';

import { Grid, Typography } from '@material-ui/core';

import { useStyles } from './styles';

export default function SequenceView() {
  const styles = useStyles();

  const {
    basicInfo: {
      sequence
    }
  } = useSelector(state => state.provisionalReceiptConfig);

  return(
    <Grid container>
      <Grid item xs={12} style={{ marginBottom: 20, borderBottom: '1px solid #E4E7EA' }}>
        <Typography color="primary">
          <b>Série única</b>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h6" color="primary" className={styles.text}>
          Geração de RPS única: <b>{!!sequence ? 'Sim' : 'Não'}</b>
        </Typography>
      </Grid>
    </Grid>
  );
}